//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCajaChicasSantiagoVV } from "@/typings/store/plugins/easyFirestore/cajaChicasSantiagoVV";

const getters: GetterTree<StateCajaChicasSantiagoVV, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const cajaChicasSantiagoVV = {
    firestorePath: "dev/v1/cajaChicasSantiagoVV",
    firestoreRefType: "collection",
    moduleName: "cajaChicasSantiagoVV",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default cajaChicasSantiagoVV;
